// mdw-swap-content.directive.ts
import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[mdwSwap]',
})
export class MdwSwapTemplateDirective {
  public tpl = inject(TemplateRef);
}
